import React from 'react';
import { WellnessPlanBenefits } from '../../data';
import { QuestionFilledIcon } from '../../../../../../wag-react/next-components/icons';
import { BoxProps } from '../../../../../../wag-react/next-components/box';
import { Table } from '../../../../../../wag-react/core-components/table/Table';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
import { Typography } from '../../../../../../wag-react/components/Typography';
export type WellnessPlanTableProps = {
  onIconClick: (benefitName: string) => void;
} & BoxProps;
export const WellnessPlanTable = ({
  onIconClick,
  ...rest
}: WellnessPlanTableProps) => <Table style={{
  'table-layout': 'fixed'
}} {...rest} data-sentry-element="Table" data-sentry-component="WellnessPlanTable" data-sentry-source-file="index.tsx">
    {Object.keys(WellnessPlanBenefits).map(key => <Flex key={key} alignItems="center" border="2px solid #e5e5e5" borderRadius="8px" cursor="pointer" my="8px" justifyContent="space-between" height={['56px', 'null', '65px']} px={['12px', null, '28px']} {...rest}>
        <Typography fontFamily="muliBold">
          {WellnessPlanBenefits[key]}
        </Typography>

        <Flex alignItems="center">

          <QuestionFilledIcon onClick={() => onIconClick(WellnessPlanBenefits[key])} color="#d8d8d8" cursor="pointer" height="22px" ml={['8px', null, '20px']} width="22px" />
        </Flex>
      </Flex>)}
  </Table>;